import { AudioLines } from 'lucide-react';
export var AUDIO_RECORDING_LABEL = 'Audio Recording';
export var AudioArtwork = function (_a) {
    var poster = _a.poster, title = _a.title, _b = _a.variant, variant = _b === void 0 ? 'audio-bar' : _b;
    if (poster) {
        return (<>
        <img alt={title !== null && title !== void 0 ? title : "".concat(AUDIO_RECORDING_LABEL, " artwork")} className="absolute inset-0 h-full w-full object-cover object-center" src={poster}/>
        {variant === 'player' && (<div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/70 to-transparent"/>)}
      </>);
    }
    if (variant === 'player') {
        return (<div className="pointer-events-none absolute top-3 left-3 z-10 flex items-center gap-1.5 text-sm font-medium text-white/80">
        <AudioLines aria-hidden="true" className="h-4 w-4"/>
        {AUDIO_RECORDING_LABEL}
      </div>);
    }
    return (<div className="text-muted-foreground pointer-events-none absolute inset-0 flex items-center justify-center text-lg">
      {AUDIO_RECORDING_LABEL}
    </div>);
};
